import React, { useContext, useState } from "react";
import { PageContext } from "../Pages.js";
import "../../styles/form/RegisteredPage.scss";

const RegisteredPage = () => {
  const { setCurrentStep } = useContext(PageContext);

  return (
    <div className="registered-page-container">
      <img
        className="background-image"
        src="./images/end_page_background.jpg"
        alt="background-image"
      />
      <div className="text-container">
        <div className="title">成功登記</div>
        <div className="text">多謝支持</div>
      </div>
      <div className="back-button-container">
        <img
          className="back-button"
          src="./images/back_to_home_page_button.png"
          onClick={() => setCurrentStep(0)}
          alt="start-2-button"
        />
      </div>
    </div>
  );
};

export default RegisteredPage;
